import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthenticationService, CatalogService } from 'src/app/_services';
import { TranslateService } from '@ngx-translate/core';
import { BasketService } from 'src/app/_services/basket.service';
import { Router, NavigationEnd } from '@angular/router';
import { BasketProduct, BasketPrice } from 'src/app/_models';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment.prod';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilsService } from '../../../_services';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-basket-widget',
  templateUrl: './basket-widget.component.html',
  styleUrls: ['./basket-widget.component.css']
})
export class BasketWidgetComponent implements OnInit {

  public basketForm : FormGroup;
  public basketPrice : BasketPrice;
  public plannedOrder : boolean;
  public plannedOrderToCenter : boolean;

  constructor(
    public auth: AuthenticationService,
    public formBuilder: FormBuilder,
    public translate: TranslateService,
    public basket : BasketService,
    public router : Router,
    public catalog : CatalogService,
    public spinner : NgxSpinnerService,
    public dom  : DomSanitizer,
    public utils : UtilsService
    ) { 
  }

  ngOnInit() {
    setTimeout(() => {
      this.spinner.show('basketWidgetSpinner');      
    }, environment.READY_TIMEOUT);

    // basket
    this.basketForm = this.formBuilder.group({
    });
    

    this.basket.delivery.subscribe (
      result =>{
        this.plannedOrder = result == null ?  false : true ;
        if (this.plannedOrder){
            this.plannedOrderToCenter = result.tipo != 1 ;
        } else {
          this.plannedOrder = false;
          this.plannedOrderToCenter = false;
        }
    });

    this.basket.basketPrice.subscribe(bp =>{
      this.basketPrice = bp;
      setTimeout(() => {
        this.spinner.hide('basketWidgetSpinner');          
      }, environment.READY_TIMEOUT);
    })

    // this.router.events.subscribe((evt) => {
    //   if (evt instanceof NavigationEnd ) {
    //       this.basket.setCheckOut(false);
    //   }
    // });


  }

  closeDropdown() {
    document.body.click(); // simula un clic fora
  }
 
  public get inCheckOut() : Observable <boolean> {
    return this.basket.inCheckOut;
  }

  clearBasket (){
    this.spinner.show('basketWidgetSpinner');      
    this.basket.empty().subscribe();

  }

  more(bProduct : BasketProduct){
    if (bProduct.product.has_format){
      this.basket.moreFormat(bProduct).subscribe();
    } else {
      this.basket.more(bProduct.product).subscribe();
    }
  }

  less(bProduct : BasketProduct){
    if (bProduct.product.has_format){
      this.basket.lessFormat(bProduct).subscribe();
    } else {
      this.basket.less(bProduct.product).subscribe();
    }
  }
  
  remove(bProduct : BasketProduct){
    // this.spinner.show('basketWidgetSpinner');          
    this.basket.remove(bProduct).subscribe( result => {
      // this.spinner.hide('basketWidgetSpinner');
    });      
  }

}
